import { render } from "./MemberLeftNav.vue?vue&type=template&id=22745d96&scoped=true"
import script from "./MemberLeftNav.vue?vue&type=script&lang=js"
export * from "./MemberLeftNav.vue?vue&type=script&lang=js"

import "./MemberLeftNav.vue?vue&type=style&index=0&id=22745d96&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22745d96"]])

export default __exports__